module.exports = __webpack_public_path__ + "media/assets/images/tour/binder_content-df3a30a67dcf9bae6548e187f337a251.jpg";